export default __webpack_public_path__ + "static/media/card.94baa52a.jpg";